import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ThreeDots } from "react-loader-spinner";
import { Link, useParams } from "react-router";
import { faEdit, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import InfiniteScroll from "react-infinite-scroll-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Accordion } from "react-bootstrap";

import {
  getItemFromStorage,
  setItemToStorage,
} from "../../../../system";
import {
  emptyString,
  pathConstant,
  loginConstants,
  managersConstants,
  screenSize,
  EMPTY_ARRAY_LENGTH,
  PAGINATION_INDEXING,
  LIST_PAGE_SIZE,
  MANAGERS_LABELS,
  modalSize,
} from "../../constants";
import {
  brandProfileConstants,
  systemGreenColor,
} from "../../../shared-screens/constants";
import {
  useSpinner,
  Spinner,
  useWindowWidth,
  handleAsyncAction,
} from "../../../../shared";
import {
  getConfirmationModal,
  addManagerPreviewModal,
} from "../../../../shared/components/popups/allModals";
import { managersActions } from "../../redux/actions";
import { storeActions } from "../../../admin-screens/redux/actions";

const buildManagersQuery = (from) => ({
  search: emptyString,
  from,
});

const Managers = (props) => {
  const {
    user,
    managersReducer: { allManagers },
    getStoreById,
    deleteManager,
    emptyAllManagers,
    getManagersByGroupId,
    removeManagerLocation,
  } = props;

  let userRole = getItemFromStorage(loginConstants.ROLE);

  const { groupId } = useParams();
  const windowWidth = useWindowWidth();

  const [from, setFrom] = useState(PAGINATION_INDEXING.FIRST_PAGE_INDEX);
  const [showModal, setShowModal] = useState(false);
  const [modalElement, setModalElement] = useState(null);
  const [managers, setManagers] = useState(allManagers);

  //Setting modal component
  const setComponent = (component) => {
    setModalElement(component);
    setShowModal(true);
  };

  // Load next page of managers (infinite scroll)
  const loadNextPage = () => {
    setFrom(() => allManagers?.length ?? EMPTY_ARRAY_LENGTH);
  };

  const initialPageQuery = buildManagersQuery(
    PAGINATION_INDEXING.FIRST_PAGE_INDEX
  );

  //Modal to update the manager
  const updateManagerDetails = (e, manager) => {
    e.stopPropagation();
    setComponent(
      addManagerPreviewModal({
        onClose: () => setShowModal(false),
        row: manager,
        editMode: true,
        groupId: manager?.groupId,
        queryString: initialPageQuery,
        brandId: manager?.brandId,
      })
    );
  };
  //Modal to delete the manager
  const deleteManagerModal = (e, manager) => {
    e.stopPropagation();
    setComponent(
      getConfirmationModal({
        onClose: () => setShowModal(false),
        Title: MANAGERS_LABELS.CONFIRM,
        message: `Are you sure you want to delete ${manager.name}?`,
        ModalSize: modalSize.MODAL_SIZE_MEDIUM,
        onConfirm: () =>
          handleAsyncAction(
            deleteManager(manager.id, initialPageQuery, groupId, userRole),
            { onSuccess: () => setShowModal(false) },
          ),
      })
    );
  };

  //Modal to remove the manager location
  const removeManagerLocationModal = (
    e,
    managerLocationId,
    managerId,
    managerLocationName
  ) => {
    e.stopPropagation();
    setComponent(
      getConfirmationModal({
        onClose: () => setShowModal(false),
        Title: MANAGERS_LABELS.CONFIRM,
        message: `Are you sure you want to remove ${managerLocationName}?`,
        ModalSize: modalSize.MODAL_SIZE_MEDIUM,
        onConfirm: () =>
          handleAsyncAction(
            removeManagerLocation(
              managerLocationId,
              managerId,
              initialPageQuery,
              groupId,
              userRole,
            ),
            { onSuccess: () => setShowModal(false) },
          ),
      })
    );
  };

  // Show loading while a request is running.
  const spinner = useSpinner();

  //Handle store name click
  const handleClickStoreName = (location) => {
    setItemToStorage(loginConstants.LOCATION_ID, location.id);
    setItemToStorage(
      brandProfileConstants.LOCATION_STATE,
      JSON.stringify({
        name: pathConstant.GROUP_MANAGER,
      })
    );
  };

  useEffect(() => {
    getManagersByGroupId(buildManagersQuery(from), groupId);
    // eslint-disable-next-line
  }, [from]);

  useEffect(() => {
    setManagers(allManagers);
  }, [allManagers]);

  useEffect(() => {
    getStoreById(user.brandId);
    emptyAllManagers();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {/*Modal here */}
      {showModal && modalElement}
      {/*End Modal */}
      {spinner(managersConstants.UPDATE_MANAGERS) && <Spinner />}
      <div className="container-fluid py-3">
        <div className="notification-form shadow card mb-3 p-3">
          <InfiniteScroll
            dataLength={managers?.length ?? EMPTY_ARRAY_LENGTH}
            next={loadNextPage}
            hasMore={
              managers?.length % LIST_PAGE_SIZE === EMPTY_ARRAY_LENGTH &&
              managers?.length !== EMPTY_ARRAY_LENGTH
            }
            loader={
              spinner(managersConstants.MANAGERS_DATA) ? (
                <ThreeDots ariaLabel="loading-indicator" />
              ) : (
                emptyString
              )
            }
            scrollableTarget={
              windowWidth < screenSize.LAYOUT_DESKTOP
                ? emptyString
                : "main-container"
            }
          >
            <div className="vertical-scroll ">
              <div className="row p-0 m-0">
                <div className="col-6">
                  <p className="font-12-px bold-6 p-2 m-0">
                    {MANAGERS_LABELS.NAME}
                  </p>
                </div>
                <div className="col-3">
                  <p className="font-12-px bold-6 p-2 m-0">
                    {MANAGERS_LABELS.STORES}
                  </p>
                </div>

                <div className="col-3">
                  <p className="font-12-px bold-6 p-2 m-0">
                    {MANAGERS_LABELS.ACTIONS}
                  </p>
                </div>
              </div>
              <Accordion>
                {managers?.length > EMPTY_ARRAY_LENGTH ? (
                  managers?.map((manager, index) => (
                    <Accordion.Item
                      key={manager?.id}
                      eventKey={index}
                      className="store-accordion pb-0"
                    >
                      <Accordion.Header
                        className="accordion-header"
                        data-testid="toggle-header"
                      >
                        <div className="row w-100">
                          <div className="col-6 text-break font-14-px d-flex align-items-center">
                            <p className="p-2 m-0">{manager?.name}</p>
                          </div>
                          <div className="col-3 font-14-px d-flex align-items-center">
                            <p className="p-2 m-0">{manager?.stores?.length}</p>
                          </div>

                          <div className="col-3 d-flex align-items-center">
                            <FontAwesomeIcon
                              icon={faEdit}
                              role="button"
                              className="fs-4 ms-1 pe-2 p-2"
                              aria-hidden="true"
                              data-testid="edit-icon"
                              onClick={(e) => updateManagerDetails(e, manager)}
                            />
                            <FontAwesomeIcon
                              icon={faTimesCircle}
                              data-testid="delete-icon"
                              className="text-danger fs-4 ms-1 pe-2 remove-button p-2"
                              onClick={(e) => deleteManagerModal(e, manager)}
                            />
                          </div>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body className="p-2">
                        {manager?.stores?.length > EMPTY_ARRAY_LENGTH ? (
                          <div className="locations-container sidebar-green font-14-px">
                            {manager?.stores.map((location) => (
                              <div
                                key={location?.id}
                                className="row item_direction"
                              >
                                <div className="col-8 pl-2 pointer font-14-px d-flex align-items-center p_55">
                                  <Link
                                    className={`table-links`}
                                    to={`/group-manager/${groupId}/store-performance/${location.id}`}
                                    state={{
                                      name: pathConstant.GROUP_MANAGER,
                                    }}
                                    onClick={() =>
                                      handleClickStoreName(location)
                                    }
                                  >
                                    {location.name}
                                  </Link>
                                </div>
                                <div className="col-4 d-flex align-items-center">
                                  {manager?.stores?.length > 1 && (
                                    <FontAwesomeIcon
                                      icon={faTimesCircle}
                                      data-testid={`remove-${location.id}`}
                                      className="text-danger fs-4 ms-1 pe-2 remove-button p-2"
                                      onClick={(e) =>
                                        removeManagerLocationModal(
                                          e,
                                          location.id,
                                          manager?.id,
                                          location.name
                                        )
                                      }
                                    />
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          MANAGERS_LABELS.NO_LOCATIONS
                        )}
                      </Accordion.Body>
                    </Accordion.Item>
                  ))
                ) : (
                  <p className="text-center d-flex justify-content-center align-items-center">
                    {spinner(managersConstants.MANAGERS_DATA) ? (
                      <ThreeDots
                        ariaLabel="loading-indicator"
                        color={systemGreenColor}
                      />
                    ) : (
                      <>{MANAGERS_LABELS.NO_MANAGER_FOUND}</>
                    )}
                  </p>
                )}
              </Accordion>
            </div>
          </InfiniteScroll>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  user: state.authentication.user,
  store: state.storesReducer.store,
  managersReducer: state.managersReducer,
});

const mapDispatchToProps = (dispatch) => ({
  deleteManager: (managerId, queryString, groupId, userRole) =>
    dispatch(
      managersActions.deleteManager(managerId, queryString, groupId, userRole),
    ),
  emptyAllManagers: () => dispatch(managersActions.emptyAllManagers()),

  getManagersByGroupId: (queryString, groupId) =>
    dispatch(managersActions.getManagersByGroupId(queryString, groupId)),
  removeManagerLocation: (
    brandLocationId,
    managerId,
    queryString,
    groupId,
    userRole,
  ) =>
    dispatch(
      managersActions.removeManagerLocation(
        brandLocationId,
        managerId,
        queryString,
        groupId,
        userRole,
      ),
    ),
  getStoreById: (brandId) => dispatch(storeActions.getStoreById(brandId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Managers);
